import { useQuery } from "@tanstack/react-query";
import {
	getStraightenerPickers,
	getStraightenerRuns,
	type GetStraightenerRunsParams,
} from "../repositories/StraightenerRunsRepository";

type UseStraightenerRunsParams = Omit<GetStraightenerRunsParams, "signal"> & {
	enabled?: boolean;
};

export const useStraightenerRuns = ({
	start,
	end,
	productSizeId = null,
	productTypeId = null,
	enabled = true,
}: UseStraightenerRunsParams) => {
	return useQuery({
		queryKey: ["straightenerRuns", start, end, productSizeId, productTypeId],
		queryFn: ({ signal }) =>
			getStraightenerRuns({
				start,
				end,
				productSizeId,
				productTypeId,
				signal,
			}),
		enabled: enabled && !!start && !!end,
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};

export const useStraightenerPickers = () => {
	return useQuery({
		queryKey: ["straightenerPickers"],
		queryFn: ({ signal }) => getStraightenerPickers({ signal }),
		refetchOnWindowFocus: false,
		refetchOnReconnect: false,
	});
};
